(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3DiffLegendModal', {
            templateUrl: 'app/shared/score-history/diff-legend-modal.component.html',
            bindings: { close: '&' }
        });
})(); 